import React from 'react';
import ReactDOM, { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

const container = document.getElementById("root");
const appTree = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  // Server-rendered markup present (SSR server on port 4000) — hydrate it.
  hydrateRoot(container, appTree);
} else {
  // No server-rendered markup (e.g. CRA dev server on port 3000) — plain client render.
  ReactDOM.createRoot(container).render(appTree);
}

reportWebVitals();
